import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PrivacyPolicyState {
  agreedTrials: {
    [key: string]: string[];
  };
  setAgreedTrials: (userId: string, trialId: string) => void;
}

export const usePrivacyPolicyStore = create<PrivacyPolicyState>()(
  persist(
    (set) => ({
      agreedTrials: {},
      setAgreedTrials: (userId: string, trialId: string) => {
        set(({ agreedTrials }) => {
          const updatedAgreedTrials = {
            ...agreedTrials,
            [userId]: [...(agreedTrials[userId] || []), trialId],
          };
          return { agreedTrials: updatedAgreedTrials };
        });
      },
    }),

    {
      name: 'b2b-privacy-policy',
    },
  ),
);
